// extracted by mini-css-extract-plugin
export default {"locationIcon":"EditItemGroupSettingsForm_locationIcon__ZuiFQ"};